import { useState, FormEvent } from 'react';

// Áreas de interesse — correspondência exata com os títulos da seção "Áreas de Atuação"
const AREAS_INTERESSE = [
  'Civil',
  'Imobiliário',
  'Consumidor',
  'Família',
  'Sucessões',
  'Trabalhista',
  'Empresarial',
  'Energia',
];

// Número principal para receber as mensagens do formulário (formato internacional)
const WHATSAPP_NUMERO = '5521999887645';

const ContatoSection = () => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    area: '',
    mensagem: '',
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    // Impede o comportamento padrão do formulário (sem reload, sem backend)
    e.preventDefault();

    // Monta a mensagem com estrutura exata solicitada
    const mensagem =
      `Nome Completo: ${formData.nome} | ` +
      `E-mail: ${formData.email} | ` +
      `Área de Interesse: ${formData.area} | ` +
      `Motivo do Contato: ${formData.mensagem}`;

    // Codifica a mensagem para URL
    const mensagemCodificada = encodeURIComponent(mensagem);

    // Abre o WhatsApp em nova aba com a mensagem já preenchida
    window.open(
      `https://wa.me/${WHATSAPP_NUMERO}?text=${mensagemCodificada}`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <section id="contato" className="py-16 md:py-28 bg-[#F9FAFB]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">

        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="h-px w-10 bg-[#C8A96A]" />
            <span className="text-[#C8A96A] text-xs font-semibold tracking-[0.35em] uppercase">
              Fale Conosco
            </span>
            <div className="h-px w-10 bg-[#C8A96A]" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-[#0F1E2E] mb-4">
            Entre em <span className="text-[#C8A96A]">Contato</span>
          </h2>
          <p className="text-[#2B2F33]/70 text-sm md:text-base max-w-lg mx-auto font-light">
            Atendimento com seriedade e confidencialidade. Compartilhe sua demanda e nossa equipe
            entrará em contato.
          </p>
        </div>

        {/* Grid principal: formulário + mapa (esquerda) | informações (direita) */}
        <div className="grid lg:grid-cols-2 gap-10 md:gap-16 items-start">

          {/* Coluna esquerda: Formulário + Mapa */}
          <div className="flex flex-col gap-0">

            {/* Formulário */}
            <div className="bg-white border border-[#E5E7EB] p-8 md:p-10">
              <form
                onSubmit={handleSubmit}
                className="space-y-5"
                id="form-contato-whatsapp"
              >
                {/* Nome Completo */}
                <div>
                  <label className="block text-[#0F1E2E] text-xs font-semibold tracking-widest uppercase mb-2">
                    Nome completo
                  </label>
                  <input
                    type="text"
                    name="nome"
                    required
                    value={formData.nome}
                    onChange={handleChange}
                    placeholder="Seu nome completo"
                    className="w-full border border-[#E5E7EB] px-4 py-3 text-sm text-[#2B2F33] placeholder-[#2B2F33]/30 focus:outline-none focus:border-[#C8A96A] transition-colors bg-[#F9FAFB]"
                  />
                </div>

                {/* E-mail */}
                <div>
                  <label className="block text-[#0F1E2E] text-xs font-semibold tracking-widest uppercase mb-2">
                    E-mail
                  </label>
                  <input
                    type="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="seu@email.com"
                    className="w-full border border-[#E5E7EB] px-4 py-3 text-sm text-[#2B2F33] placeholder-[#2B2F33]/30 focus:outline-none focus:border-[#C8A96A] transition-colors bg-[#F9FAFB]"
                  />
                </div>

                {/* Área de Interesse — opções espelham os títulos da seção "Áreas de Atuação" */}
                <div>
                  <label className="block text-[#0F1E2E] text-xs font-semibold tracking-widest uppercase mb-2">
                    Área de interesse
                  </label>
                  <select
                    name="area"
                    required
                    value={formData.area}
                    onChange={handleChange}
                    className="w-full border border-[#E5E7EB] px-4 py-3 text-sm text-[#2B2F33] focus:outline-none focus:border-[#C8A96A] transition-colors bg-[#F9FAFB] cursor-pointer"
                  >
                    <option value="">Selecione uma área</option>
                    {AREAS_INTERESSE.map((area) => (
                      <option key={area} value={area}>
                        Direito {area}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Mensagem */}
                <div>
                  <label className="block text-[#0F1E2E] text-xs font-semibold tracking-widest uppercase mb-2">
                    Mensagem{' '}
                    <span className="text-[#2B2F33]/40 normal-case tracking-normal">
                      ({formData.mensagem.length}/500)
                    </span>
                  </label>
                  <textarea
                    name="mensagem"
                    required
                    rows={5}
                    value={formData.mensagem}
                    onChange={handleChange}
                    maxLength={500}
                    placeholder="Descreva brevemente sua demanda jurídica..."
                    className="w-full border border-[#E5E7EB] px-4 py-3 text-sm text-[#2B2F33] placeholder-[#2B2F33]/30 focus:outline-none focus:border-[#C8A96A] transition-colors bg-[#F9FAFB] resize-none"
                  />
                </div>

                {/* Botão — abre WhatsApp com mensagem pronta */}
                <button
                  type="submit"
                  className="w-full py-4 bg-[#0F1E2E] text-[#F9FAFB] text-xs font-semibold tracking-[0.25em] uppercase hover:bg-[#1E3A5F] transition-colors duration-300 cursor-pointer whitespace-nowrap flex items-center justify-center gap-3"
                >
                  <i className="ri-whatsapp-line text-base"></i>
                  Enviar via WhatsApp
                </button>

                <p className="text-center text-[#2B2F33]/40 text-xs">
                  Todas as informações são tratadas com total confidencialidade.
                </p>
              </form>
            </div>

            {/* Mapa — abaixo do formulário, mesma largura */}
            <div className="border border-t-0 border-[#E5E7EB] bg-white">
              <div className="w-full h-56 overflow-hidden">
                <iframe
                  title="Localização Hélio de Oliveira & Santos Oliveira Advogados"
                  src="https://maps.google.com/maps?width=100%25&amp;height=300&amp;hl=pt&amp;q=Avenida+Rio+Branco+156+Rio+de+Janeiro&amp;ie=UTF8&amp;t=&amp;z=15&amp;iwloc=B&amp;output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  aria-label="Mapa localização escritório"
                />
              </div>
              <div className="px-6 py-3 border-t border-[#E5E7EB]">
                <p className="text-[#0F1E2E] text-xs font-semibold tracking-widest uppercase mb-0.5">Nossa localização</p>
                <p className="text-[#2B2F33]/60 text-xs">Av. Rio Branco, 156 – 26º andar – Centro, Rio de Janeiro – RJ</p>
              </div>
            </div>

          </div>

          {/* Coluna direita: Informações de contato + WhatsApp CTA */}
          <div className="flex flex-col gap-8">

            {/* Endereço */}
            <div className="flex gap-5">
              <div className="w-11 h-11 flex items-center justify-center border border-[#C8A96A]/30 flex-shrink-0">
                <i className="ri-map-pin-2-line text-[#C8A96A] text-lg"></i>
              </div>
              <div>
                <p className="text-[#0F1E2E] text-xs font-semibold tracking-widest uppercase mb-1">Endereço</p>
                <p className="text-[#2B2F33] text-sm">Avenida Rio Branco n.º 156, 26º andar, salas 2619 e 2620</p>
                <p className="text-[#2B2F33] text-sm">(Edifício Avenida Central)</p>
                <p className="text-[#2B2F33]/70 text-sm">Centro – Rio de Janeiro – RJ, CEP: 20.040-003</p>
              </div>
            </div>

            {/* Telefones */}
            <div className="flex gap-5">
              <div className="w-11 h-11 flex items-center justify-center border border-[#C8A96A]/30 flex-shrink-0">
                <i className="ri-phone-line text-[#C8A96A] text-lg"></i>
              </div>
              <div>
                <p className="text-[#0F1E2E] text-xs font-semibold tracking-widest uppercase mb-1">Telefones</p>
                <p className="text-[#2B2F33] text-sm">(21) 3197.2611</p>
                <p className="text-[#2B2F33] text-sm">(21) 99988-7645</p>
              </div>
            </div>

            {/* WhatsApp */}
            <div className="flex gap-5">
              <div className="w-11 h-11 flex items-center justify-center border border-[#C8A96A]/30 flex-shrink-0">
                <i className="ri-whatsapp-line text-[#C8A96A] text-lg"></i>
              </div>
              <div>
                <p className="text-[#0F1E2E] text-xs font-semibold tracking-widest uppercase mb-1">WhatsApp</p>
                <p className="text-[#2B2F33] text-sm">(21) 99988-7645</p>
                <p className="text-[#2B2F33] text-sm">(21) 99975-1955 – Dr. Helio de Oliveira</p>
                <p className="text-[#2B2F33] text-sm">(21) 98092-3713 – Dr. Filipe Santos Oliveira</p>
                <p className="text-[#2B2F33] text-sm">(21) 97008-9448 – Dr. Bruno Santos Oliveira</p>
              </div>
            </div>

            {/* E-mail */}
            <div className="flex gap-5">
              <div className="w-11 h-11 flex items-center justify-center border border-[#C8A96A]/30 flex-shrink-0">
                <i className="ri-mail-line text-[#C8A96A] text-lg"></i>
              </div>
              <div>
                <p className="text-[#0F1E2E] text-xs font-semibold tracking-widest uppercase mb-1">E-mail</p>
                <a
                  href="mailto:contato@hosoadv.com.br"
                  className="text-[#2B2F33] text-sm hover:text-[#C8A96A] transition-colors cursor-pointer"
                >
                  contato@hosoadv.com.br
                </a>
              </div>
            </div>

            {/* Redes Sociais */}
            <div className="flex gap-5">
              <div className="w-11 h-11 flex items-center justify-center border border-[#C8A96A]/30 flex-shrink-0">
                <i className="ri-share-line text-[#C8A96A] text-lg"></i>
              </div>
              <div>
                <p className="text-[#0F1E2E] text-xs font-semibold tracking-widest uppercase mb-3">Redes Sociais</p>
                <div className="flex items-center gap-3">
                  <a
                    href="https://www.linkedin.com/company/hosoadv/"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="w-9 h-9 flex items-center justify-center border border-[#C8A96A]/30 text-[#2B2F33] hover:border-[#C8A96A] hover:text-[#C8A96A] transition-all duration-300 cursor-pointer"
                    title="LinkedIn"
                  >
                    <i className="ri-linkedin-fill text-sm"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/hosoadv"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="w-9 h-9 flex items-center justify-center border border-[#C8A96A]/30 text-[#2B2F33] hover:border-[#C8A96A] hover:text-[#C8A96A] transition-all duration-300 cursor-pointer"
                    title="Instagram @hosoadv"
                  >
                    <i className="ri-instagram-line text-sm"></i>
                  </a>
                  <a
                    href="https://www.facebook.com/hosoadv"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="w-9 h-9 flex items-center justify-center border border-[#C8A96A]/30 text-[#2B2F33] hover:border-[#C8A96A] hover:text-[#C8A96A] transition-all duration-300 cursor-pointer"
                    title="Facebook"
                  >
                    <i className="ri-facebook-fill text-sm"></i>
                  </a>
                </div>
                <div className="mt-2 space-y-1">
                  <p className="text-[#2B2F33]/60 text-xs">linkedin.com/company/hosoadv</p>
                  <p className="text-[#2B2F33]/60 text-xs">@hosoadv</p>
                  <p className="text-[#2B2F33]/60 text-xs">facebook.com/hosoadv</p>
                </div>
              </div>
            </div>

            {/* WhatsApp CTA — alinhado com o fim do formulário */}
            <div className="border-t border-[#E5E7EB] pt-8">
              <p className="text-[#0F1E2E] text-xs font-semibold tracking-widest uppercase mb-4">
                Atendimento imediato via WhatsApp
              </p>
              <div className="flex flex-col gap-3">
                <div className="flex flex-col sm:flex-row gap-3">
                  <a
                    href="https://wa.me/5521999887645?text=Ol%C3%A1%2C%20gostaria%20de%20falar%20com%20um%20advogado."
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="inline-flex items-center gap-3 px-6 py-3.5 bg-[#C8A96A] text-[#0F1E2E] text-xs font-bold tracking-widest uppercase hover:bg-[#b89558] transition-colors duration-300 cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-line text-base"></i>
                    (21) 99988-7645
                  </a>
                  <a
                    href="https://wa.me/5521999751955?text=Ol%C3%A1%2C%20gostaria%20de%20falar%20com%20o%20Dr.%20Helio%20de%20Oliveira."
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="inline-flex items-center gap-3 px-6 py-3.5 border border-[#C8A96A] text-[#C8A96A] text-xs font-bold tracking-widest uppercase hover:bg-[#C8A96A] hover:text-[#0F1E2E] transition-colors duration-300 cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-line text-base"></i>
                    Dr. Helio – (21) 99975-1955
                  </a>
                </div>
                <div className="flex flex-col sm:flex-row gap-3">
                  <a
                    href="https://wa.me/5521980923713?text=Ol%C3%A1%2C%20gostaria%20de%20falar%20com%20o%20Dr.%20Filipe%20Santos%20Oliveira."
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="inline-flex items-center gap-3 px-6 py-3.5 border border-[#C8A96A] text-[#C8A96A] text-xs font-bold tracking-widest uppercase hover:bg-[#C8A96A] hover:text-[#0F1E2E] transition-colors duration-300 cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-line text-base"></i>
                    Dr. Filipe – (21) 98092-3713
                  </a>
                  <a
                    href="https://wa.me/5521970089448?text=Ol%C3%A1%2C%20gostaria%20de%20falar%20com%20o%20Dr.%20Bruno%20Santos%20Oliveira."
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="inline-flex items-center gap-3 px-6 py-3.5 border border-[#C8A96A] text-[#C8A96A] text-xs font-bold tracking-widest uppercase hover:bg-[#C8A96A] hover:text-[#0F1E2E] transition-colors duration-300 cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-line text-base"></i>
                    Dr. Bruno – (21) 97008-9448
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default ContatoSection;
